import React from "react";

const ViuLogo = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 370.8 265.1"
    >
      <defs>
        <style>
          {`.cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#ff2300;}`}
        </style>
      </defs>
      <g id="rahmen">
        <rect className="cls-1" width="370.8" height="265.1" />
      </g>
      <g id="logo">
        <path
          className="cls-2"
          d="M185.1,40.8h0c6.4,0,11.6,2,15.8,5.9,4.1,4,6.2,9,6.2,15s-2.1,11.1-6.2,15-9.4,5.9-15.8,5.9-11.6-2-15.6-5.9c-4.1-4-6.1-9-6.1-15s2-11.1,6.1-15,9.3-5.9,15.6-5.9h0ZM293.5,202.6l5.2,15.7h28.4v-113.4h-36.9v75.5c-5.6,9.7-12.3,14.5-20.1,14.5-4.1,0-7.1-1.2-9-3.6-2-2.4-2.9-6.7-2.9-12.7v-73.7h-36.9v78.3c0,12.3,2.9,21.9,8.8,28.8,5.8,6.9,14.4,10.3,25.8,10.3,16-.1,28.6-6.6,37.6-19.7h0ZM125.8,104.9l-21.9,76.2-21-76.2h-39.2l38,113.4h43.7l36.7-112.4,4.8,14.4v97.9h36.9v-113.3h-78Z"
        />
      </g>
    </svg>
  );
};

export default ViuLogo;
